import React, {useContext} from "react"

// context
import { CatalogueContext } from "../../context/CatalogueContext"

// components
import Footer from "./Footer"
import Header from "./Header"
import LoadingScreen from "./LoadingScreen"

function Scaffolding(props) {
  // context
  let catalogue = useContext(CatalogueContext)

  // display a loading screen?
  let loadingScreen = null
  if(!catalogue.isReady) {
    loadingScreen = <LoadingScreen />
  }
  
  return (
    <div id="s-scaffolding">
      <Header />
      {props.children}
      {loadingScreen}
      <Footer />
    </div>
  )
}

export default Scaffolding